import React from 'react';
import PropTypes from "prop-types";

function ChallengeDropdownItem({item, with_version = false}) {
    function renderChallengeMeasure() {
        if ('metric' === item.measure) {
            return (
                <div className="autocomplete-dropdown-menu-item-second">Metric edition</div>
            );
        } else if ('imperial' === item.measure) {
            return (
                <div className="autocomplete-dropdown-menu-item-second">US edition</div>
            );
        }

        return null;
    }

    return (
        <div>
            <div className="autocomplete-dropdown-menu-item-title">{item.name}{with_version ? (' v.' + item.version) : ''}</div>
            {renderChallengeMeasure()}
        </div>
    );
}

ChallengeDropdownItem.propTypes = {
    item: PropTypes.shape({
        name: PropTypes.string.isRequired,
        measure: PropTypes.string,
        version: PropTypes.number
    }).isRequired,
    with_version: PropTypes.bool
};

export default ChallengeDropdownItem;
